
import { Options, Vue } from 'vue-class-component';
import { mapMutations, mapState } from 'vuex';

@Options({
  methods: mapMutations([
    'SET_CURRENT_FRAGMENT_LOADER',
    'SET_PAST_FRAGMENT_LOADER',
    'STATUS_CLOSE_FRAGMENT_3',
  ]),
  computed: mapState(['pastFragmentLoader']),
})
export default class Fragment1 extends Vue {
  touchstartX = 0;

  touchendX = 0;

  hideRight = false;

  entryRight = false;

  SET_CURRENT_FRAGMENT_LOADER!: (fragment: number) => void;

  SET_PAST_FRAGMENT_LOADER!: (fragment: number) => void;

  STATUS_CLOSE_FRAGMENT_3!: (status: boolean) => void;

  pastFragmentLoader!: number;

  async handleGesture(): Promise<void> {
    if (this.touchendX > this.touchstartX) {
      this.entryRight = false;
      this.hideRight = true;

      this.SET_CURRENT_FRAGMENT_LOADER(2);

      await setTimeout(() => {
        this.STATUS_CLOSE_FRAGMENT_3(false);
      }, 500);
    }
  }

  touchStart(e: TouchEvent): void {
    this.touchstartX = e.changedTouches[0].screenX;
  }

  touchEnd(e: TouchEvent): void {
    this.touchendX = e.changedTouches[0].screenX;
    this.handleGesture();
  }

  goLogin(): void {
    this.$router.push({ name: 'Login' });
  }

  mounted(): void {
    if (this.pastFragmentLoader === 2) {
      this.hideRight = false;
      this.entryRight = true;
    }
    this.SET_PAST_FRAGMENT_LOADER(3);
    this.STATUS_CLOSE_FRAGMENT_3(true);
  }
}
